module.exports = __webpack_public_path__ + "img/done.7a12b054.svg";